import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { gridColumn } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import { type ColumnsType } from '../utils/buildColumns'
import BasicRow from './BasicRow'
import DailyRow from './DailyRow'
import WeeklyRow from './WeeklyRow'

interface Props {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  contractVersions: ContractVersions
}
const ShiftsRowPerView = ({ shiftsRow, columns, contractVersions }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [{ view }] = useSchedule()
  const hasBackupShifts = hasFeatureFlag(ShiftManagementFeatureFlags.SHIFT_MANAGEMENT_BACKUP_SHIFTS)

  // Slice the first one which belongs to the employee/areas first cell
  const cells = useUnsafeMemo(() => columns.slice(1), [columns])

  if (view.isDaily)
    return (
      <Box style={{ ...gridColumn(1, columns.length) }}>
        <DailyRow shiftsRow={shiftsRow} columns={cells} contractVersions={contractVersions} />
      </Box>
    )

  if (view.isWeekly && hasBackupShifts && !view.isByAreas)
    return (
      <Box style={{ ...gridColumn(1, columns.length) }}>
        <WeeklyRow shiftsRow={shiftsRow} columns={cells} contractVersions={contractVersions} />
      </Box>
    )

  return <BasicRow shiftsRow={shiftsRow} columns={cells} contractVersions={contractVersions} />
}

export default observer(ShiftsRowPerView)
